<img src="../../../assets/rexpay/opay-bank.svg" />

<p>
  You will be redirected to OPAY to complete your payment in
  <span style="color: #f25b61">{{ countdown }}s</span>
</p>

<!-- <button
  class="btn w-100 form-btn text-white no-margin-l no-margin-r"
  [style.background-color]="
    whiteLabelInfo()?.brandColor ? whiteLabelInfo()?.brandColor : '#ed1c25'
  "
  type="button"
  (click)="makePayment()"
>
  <span>Pay</span>
</button> -->

<div
  class="footer"
  style="margin-top: 30px; text-align: center; font-size: 12px"
>
  Powered By:

  @if (!whiteLabelInfo()) {
    <img src="../../../assets/rexpay/ga.png" />
  } @else {
    <img
      [src]="whiteLabelInfo()?.logoUrl"
      alt="logo"
      class="white-labelled-logo"
    />
  }
</div>
